import React from 'react'
import { useRecoilState } from 'recoil'

import closeButton from '@/assets/common/join/closeButton.png'
import { MvnoCheckValue } from '@/features/join/store'
import { COLOR } from '@/shared/constant/color'
import useWindowDimensions from '@/shared/hooks/useGetWindowSize'
import { CustomBtn } from '@/styles/common/CommonForm/buttonform'
import { MVNOPopupWrap, PopupLayer, TermsCheckBox } from '@/styles/views/Terms'

const MVNOModal = (props: any) => {
  const { option, ClickFunc, ClickFunc2 } = props
  const { title, content } = option
  const [mvnoCheckValue, setMvnoCheckValue] = useRecoilState(MvnoCheckValue)
  const { width } = useWindowDimensions()

  const acceptKTTerms = (e: React.ChangeEvent<HTMLInputElement>) => {
    setMvnoCheckValue(e.target.checked)
  }

  const modalClose = () => {
    ClickFunc() //toggle
    setMvnoCheckValue(false)
  }

  const checkTermTrue = () => {
    if (!mvnoCheckValue) {
      if (window.confirm('서비스 이용을 위해 약관 동의가 필요합니다.\n모두 동의하시겠습니까?')) {
        setMvnoCheckValue(true)
        ClickFunc2() // 캡챠 이동
      }
    } else {
      ClickFunc2()
    }
  }

  return (
    <PopupLayer>
      <MVNOPopupWrap className="popup_contents">
        <img src={closeButton} className="close-btn" alt="" onClick={modalClose} />
        <div className="top">
          <h4 className="description">
            KT MVNO(알뜰폰) 추가
            <br />
            약관 동의가 필요합니다.
          </h4>
          <h4 className="title">아래 약관 확인 후 동의해주세요.</h4>
        </div>
        <div className="terms-wrap">
          <div className="check-wrap">
            <input type="checkbox" id="terms-check" onChange={acceptKTTerms} />
            <TermsCheckBox htmlFor="terms-check" isChecked={mvnoCheckValue}>
              <p dangerouslySetInnerHTML={{ __html: decodeURIComponent(escape(atob(title))) }} />
              <i className="icon" />
            </TermsCheckBox>
          </div>
          <div className="terms-contents-wrap">
            <p
              className="terms-contents"
              dangerouslySetInnerHTML={{ __html: decodeURIComponent(escape(atob(content))) }}
            />
          </div>
        </div>
        <CustomBtn
          id="common_btn"
          color={COLOR.white}
          bgColor={COLOR.point1}
          borderRadius={'40px'}
          width={width > 1200 ? '356px' : '328px'}
          height={width > 1200 ? '56px' : '44px'}
          fontSize={width > 1200 ? '18px' : '14px'}
          fontFamily={width > 1200 ? 'NanumSquareNeoHeavy, sans-serif' : 'NotoSansBold, sans-serif'}
          onClick={checkTermTrue}
        >
          <span>동의 및 인증번호 받기</span>
        </CustomBtn>
      </MVNOPopupWrap>
    </PopupLayer>
  )
}
export default MVNOModal
